const SerbiaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112306)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M20 0C8.95437 0 0 8.95437 0 20C0 22.4464 0.440078 24.7899 1.24398 26.9565H38.7561C39.56 24.7899 40 22.4464 40 20C40 8.95437 31.0456 0 20 0Z"
        fill="#0052B4"
      />
      <path
        d="M19.9997 0C11.4004 0 4.06951 5.4275 1.24365 13.0435H38.7558C35.9298 5.4275 28.599 0 19.9997 0Z"
        fill="#D80027"
      />
      <path
        d="M5.17139 11.3047V21.2817C5.17139 26.957 12.5855 28.696 12.5855 28.696C12.5855 28.696 19.9996 26.957 19.9996 21.2817V11.3047H5.17139Z"
        fill="#D80027"
      />
      <path
        d="M8.23779 13.0446H16.9335V9.56629L15.1944 10.4358L12.5857 7.82715L9.97693 10.4358L8.23779 9.56629V13.0446Z"
        fill="#FFDA44"
      />
      <path
        d="M18.2609 22.6707L12.6087 17.0186L6.95654 22.6707L8.80115 24.5154L12.6087 20.7078L16.4163 24.5154L18.2609 22.6707Z"
        fill="#FFDA44"
      />
      <path
        d="M18.2609 17.3917H15.6237C15.772 17.1358 15.8583 16.8394 15.8583 16.5223C15.8583 15.5617 15.0796 14.7832 14.1191 14.7832C13.4554 14.7832 12.8791 15.1549 12.5859 15.7014C12.2927 15.155 11.7164 14.7832 11.0527 14.7832C10.0922 14.7832 9.31357 15.5617 9.31357 16.5223C9.31357 16.8394 9.39982 17.1359 9.54811 17.3917H6.95654C6.95654 18.3523 7.79318 19.1309 8.75357 19.1309H8.69568C8.69568 20.0914 9.47428 20.87 10.4348 20.87C10.4348 21.7205 11.0456 22.427 11.8522 22.5783L10.4819 25.6722C11.1387 25.9391 11.8563 26.0874 12.6088 26.0874C13.3613 26.0874 14.079 25.9391 14.7357 25.6722L13.3654 22.5783C14.172 22.4272 14.7828 21.7205 14.7828 20.87C15.7433 20.87 16.5219 20.0914 16.5219 19.1309H16.464C17.4244 19.1309 18.2609 18.3522 18.2609 17.3917Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112306">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SerbiaSvg;
